import { FilterName } from "../enums/filter-name";
import { IFilters } from "../interfaces/filters-state";

const ID_FILTER_NAMES: FilterName[] = [FilterName.FarmId, FilterName.SeasonId];

export function normalizeFilterValue(
  filter: FilterName,
  value: IFilters[FilterName]
): IFilters[FilterName] {
  if (!ID_FILTER_NAMES.includes(filter) || typeof value !== "string") {
    return value;
  }
  return value.toLowerCase();
}
